import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: '客户资料',
  editTitle: '客户资料',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: true,
  viewBtn: false,
  rowKey: 'loanInformationId',
  dialogType: 'dialog',
  reserveSelection: true,
  dialogClickModal: false,
  column: [
    {
      label: '进件编号',
      prop: 'businessCode',
      display: false,
      search: true,
      searchOrder: 996,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 998,
      searchPlaceholder: '请输入租赁人',
      display: false,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      filterable: true,
      multiple: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    // {
    //   label: "手机号",
    //   prop: "phoneNumber",
    //   span: 24,
    //   display: false,
    //   hide: false,
    // },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'select',
      display: false,
      search: true,
      searchMultiple: true,
      showColumn: false,
      hide: true,
      searchOrder: 999,
      dicData: store.getters.porductTypes,
    },
    {
      label: '创建日期',
      prop: 'lendingTime',
      span: 24,
      display: false,
      hide: false,
      formatter: (val, value) => {
        return value ? value : '-';
      },
    },
    {
      label: '创建日期',
      prop: 'createTimeRange',
      span: 24,
      type: 'daterange',
      valueFormat: 'yyyy-MM-dd',
      searchRange: true,
      display: false,
      hide: true,
      searchOrder: 997,
      search: true,
    },
    {
      label: '产品类型',
      prop: 'rentType',
      display: false,
      type: 'select',
      hide: false,
      dicData: store.getters.porductTypes,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      span: 24,
      search: false,
      display: false,
    },
    {
      label: 'id',
      prop: 'loanInformationId',
      display: false,
      hide: true,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      span: 24,
      display: false,
    },
    {
      label: '滞留日期',
      prop: 'residenceTime',
      span: 24,
      display: false,
      hide: false,
      formatter: (val, value) => {
        return value ? value : '-';
      },
    },
  ],
};
